export const AUTH0_DOMAIN = 'dev-40o4wugd4uvlu2im.us.auth0.com';
export const AUTH0_CLIENT_ID = 'CGdx2j9hrXDNNe2RMfGuI0gFzY4mFAyg';
export const AUTH0_LOGIN_REDIRECT_URI = process.env.REACT_APP_REDIRECT;
export const AUTH0_REALM = 'Username-Password-Authentication';
export const AUTH0_USER_SCOPE = 'openid profile email';
export const AUTH0_LOGIN_RESPONSE_TYPE = 'token';
export const AUTH0_LOGOUT_URI = process.env.REACT_APP_LOGOUT;